import { convertNumberToString, convertStringToNumber } from "../mixins/filters";

const vat = {
	state: () => ({
		vatName: "TVA",
		vatValues: [20, 10, 8.5, 5.5, 2.1, 0],
		selectedVatValue: 20,
		// selectedVatValue: null,
		couponCode: "",
		couponCodeValue: null,
		couponCodeAmount: null,
		couponCodePercent: null,
		couponCodeType: "€"
	}),
	mutations: {
		vatName(state, payload) {
			state.vatName = payload;
		},
		vatValues(state, payload) {
			let _payload = payload;

			if (typeof payload === "string") {
				_payload = _payload.split(",");
			}

			_payload = _payload.map(value => Number(value));

			state.vatValues = _payload.sort((a, b) => b- a);
		},
		selectedVatValue(state, payload) {
			state.selectedVatValue = payload;
		},
		couponCode(state, payload) {
			state.couponCode = payload;
		},
		couponCodeValue(state, payload) {
			state.couponCodeValue = payload;
		},
		couponCodeAmount(state, payload) {
			state.couponCodeAmount = payload;
		},
		couponCodePercent(state, payload) {
			state.couponCodePercent = payload;
		},
		couponCodeType(state, payload) {
			state.couponCodeType = payload;
		}
	},
	getters: {
		vats(state) {
			const _vats = [];

			state.vatValues.forEach(value => {
				if (value === 0) {
					_vats.push({ text: `Exonération de {vatName}`, value: 0 });
				} else {
					_vats.push({
						text: `${state.vatName} ${convertNumberToString(value)}%`,
						value
					});
				}
			});

			_vats.push({
				text: `{vatName} multiple`,
				value: null
			});

			return _vats;
		},
		mostUsedVatRate(state, getters, rootState) {
			if (rootState.app.config?.accounting?.vat?.preferedValue !== undefined) {
				return parseFloat(rootState.app.config.accounting.vat.preferedValue);
			}
			// make an object of {vatPercentage : count use, vatPercentage : count use}
			const document_entries_vat_use = {} 
			
			rootState.billing.table.sections.forEach(section => {
				section.forEach(section_line => {
					if (section_line.component === "entry") {
						const vatPercentage = String(section_line.data.vatPercentage);
						if (document_entries_vat_use[vatPercentage] !== undefined) {
							document_entries_vat_use[vatPercentage]++;
						} else {
							document_entries_vat_use[vatPercentage] = 1;
						}
					}
				});
			});

			if (Object.keys(document_entries_vat_use).length > 0) {
				// most used key
				const most_used_key = Object.keys(document_entries_vat_use).reduce((accumulator, key) => {

					if (document_entries_vat_use[accumulator] === document_entries_vat_use[key])
						return (parseFloat(accumulator) > parseFloat(key)) ? accumulator : key;

					return document_entries_vat_use[accumulator] > document_entries_vat_use[key] ? accumulator : key;
				});

				// return the most used key as float value
				return (most_used_key);
			}
			return state.selectedVatValue
		}
	},
	actions: {
		checkVatValues(_, vats) {
			if (vats.length > 0) {
				let _vats = [];

				for (const vat of vats) {
					const vatPercentageAsNumber = convertStringToNumber(vat);

					_vats.push(vatPercentageAsNumber);
				}

				// All vats are the same
				const equality = _vats.every((val, i, arr) => val === arr[0]);

				if (equality) {
					return _vats[0];
				}

				// Set to "TVA multiple"
				return null;
			}
		},
		checkDownpaymentVatValues(_, totals) {
			const _totals = { ...totals };

			if (_totals) {
				let _vats = [];

				for (const vat of Object.values(_totals)) {
					if (vat) {
						delete vat.total;

						if (Object.keys(vat).length === 1) {
							const vatValue = Object.keys(vat)[0];

							if (vatValue === "0") {
								_vats.push(0);
							} else {
								_vats.push(convertStringToNumber(vatValue) / 100);
							}
						} else {
							return null;
						}
					}
				}

				// All vats are the same
				const equality = _vats.every((val, i, arr) => val === arr[0]);

				if (equality) {
					return _vats[0];
				}

				// Set to "TVA multiple"
				return null;
			}
		}
	}
};

export default vat;
